export const bigintFromBlob = async (blob: Blob) =>
  new DataView(await blob.arrayBuffer()).getBigInt64(0, true);

export const messageFromBlob = async (blob: Blob) => {
  let remainingBytes = blob.size;
  let offset = 0;
  const data: bigint[] = [];

  const view = new DataView(await blob.arrayBuffer());

  const type = view.getInt32(offset, true);
  offset += 4;
  remainingBytes -= 4;

  while (remainingBytes > 0) {
    data.push(view.getBigInt64(offset, true));
    offset += 8;
    remainingBytes -= 8;
  }

  return {
    type,
    data,
  };
};
